import React, { useEffect } from 'react';
import { Button, Result } from 'antd';
import { Routes, Route, useNavigate, useParams } from 'react-router-dom';
import AdminLayout from './components/AdminLayout';
import Login from './pages/admin/Login';
import PosterList from './pages/admin/PosterList';
import CategoryManage from './pages/admin/CategoryManage';
import ImageLibraryManage from './pages/admin/ImageLibraryManage';
import BackgroundImageManage from './pages/admin/BackgroundImageManage';
import MaterialItemManage from './pages/admin/MaterialItemManage';
import BuiltinAssetManage from './pages/admin/BuiltinAssetManage';
import FontAssetManage from './pages/admin/FontAssetManage';
import TextStyleManage from './pages/admin/TextStyleManage';
import Home from './pages/public/Home';
import ImageLibrary from './pages/public/ImageLibrary';
import PosterDetail from './pages/public/PosterDetail';

function EditorRedirect() {
  const { posterUuid } = useParams();

  useEffect(() => {
    window.location.replace(`https://imgedit.zl6.cn/?posterUuid=${encodeURIComponent(posterUuid || '')}`);
  }, [posterUuid]);

  return null;
}

function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f8fafc' }}>
      <Result
        status="404"
        title="404"
        subTitle="页面不存在"
        extra={
          <Button type="primary" onClick={() => navigate('/')}>
            返回首页
          </Button>
        }
      />
    </div>
  );
}

function App() {
  return (
    <Routes>
      {/* 后台管理 */}
      <Route path="/admin/login" element={<NotFoundPage />} />
      <Route path="/admin/*" element={<NotFoundPage />} />
      <Route path="/dindoor/login" element={<Login />} />
      <Route path="/dindoor" element={<AdminLayout />}>
        <Route index element={<PosterList />} />
        <Route path="categories" element={<CategoryManage />} />
        <Route path="image-library" element={<ImageLibraryManage />} />
        <Route path="background-images" element={<BackgroundImageManage />} />
        <Route path="material-items" element={<MaterialItemManage />} />
        <Route path="builtin-assets" element={<BuiltinAssetManage />} />
        <Route path="font-assets" element={<FontAssetManage />} />
        <Route path="text-styles" element={<TextStyleManage />} />
      </Route>

      {/* 前台展示 */}
      <Route path="/" element={<Home />} />
      <Route path="/image-library" element={<ImageLibrary />} />
      <Route path="/poster/:posterUuid" element={<PosterDetail />} />
      <Route path="/editor/:posterUuid" element={<EditorRedirect />} />
      <Route path="/editor-fabric/:posterUuid" element={<EditorRedirect />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export default App;
